export const getValues = action => {
  switch (action) {
    case 'assign_operators':
    case 'delete_assigned_operators':
      return { text: 'dashboard_manage-operators', pathname: '/dashboard/management/operators' }
    case 'add_tags':
    case 'remove_tags':
      return { text: 'dashboard_manage-labels', pathname: '/dashboard/configurations/categories' }
    case 'add_to_folder':
    case 'delete_from_folder':
      return { text: 'dashboard_manage-folders', pathname: '/dashboard/configurations/folders' }
    default:
      return { text: '', pathname: '' }
  }
}